import { TextBox } from '@apply/components';
import { useExperienceLender } from '../../fields/ExperienceFields';

interface LenderProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
    validator?: React.ReactNode;
}

export const Lender: React.FC<LenderProps> = ({ experienceId, required = false, readOnly = false, validator }) => {
    const label = 'Lender ';
    const [lender, set_lender] = useExperienceLender(experienceId);

    return (
        <>
            <TextBox
                id='experienceLender'
                value={lender}
                onChange={(value) => set_lender(value)}
                label={label}
                required={required}
                width='100%'
                readOnly={readOnly}
                maxLength={100}
                validator={validator}
            />
        </>
    );
};
